<mat-dialog-content>
  <h3>{{ title }}</h3>
  <app-suspect-image [cancellationId]="imageKey"></app-suspect-image>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
